import { __awaiter, __extends, __generator } from "tslib";
import { CartActions } from '../../actions/CartActions/CartActions';
import { SecondaryEvents } from '../../constants';
import { BaseCurrentCartService, CurrentCartService, } from './CurrentCartService';
import { serialize, deserialize } from './serialize';
var origin = 'current-cart-service';
var SecondaryCurrentCartService = /** @class */ (function (_super) {
    __extends(SecondaryCurrentCartService, _super);
    function SecondaryCurrentCartService(props) {
        var _this = _super.call(this, props) || this;
        _this.promiseHandlers = {};
        _this.cartActions = new CartActions({
            siteStore: _this.siteStore,
            origin: origin,
            originatedInWorker: false,
            context: props.context,
        }, function () { return _this.invalidateAndReload(); });
        _this.waitForPrimaryReady = _this.waitForPrimaryOrInit(props);
        return _this;
    }
    SecondaryCurrentCartService.prototype.waitForPrimaryOrInit = function (props) {
        var _this = this;
        // eslint-disable-next-line prefer-const
        var ackEventSubscribeId;
        var resolve;
        var promise = new Promise(function (r) { return (resolve = r); });
        var timeoutId = setTimeout(function () {
            ackEventSubscribeId && _this.apis.pubSub.unsubscribe(SecondaryEvents.ACK, ackEventSubscribeId);
            var primaryCurrentCartService = new CurrentCartService(props);
            primaryCurrentCartService.init();
            resolve();
        }, 200);
        ackEventSubscribeId = this.apis.pubSub.subscribe(SecondaryEvents.ACK, function () {
            clearTimeout(timeoutId);
            _this.apis.pubSub.unsubscribe(SecondaryEvents.ACK, ackEventSubscribeId);
            resolve();
        }, false);
        this.apis.pubSub.publish(SecondaryEvents.HEALTH_CHECK, {}, false);
        return promise;
    };
    SecondaryCurrentCartService.prototype.init = function () {
        this.listenOnCacheChanges();
    };
    SecondaryCurrentCartService.prototype.getCurrentCart = function () {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.GetRequest);
    };
    SecondaryCurrentCartService.prototype.getCurrentCartV1 = function () {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.GetV1Request);
    };
    SecondaryCurrentCartService.prototype.getCurrentCartGQL = function (options) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.GetGQLRequest, [options]);
    };
    SecondaryCurrentCartService.prototype.calculateCurrentCart = function (options) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.CalculateCurrentCart, [options]);
    };
    SecondaryCurrentCartService.prototype.estimateCurrentCartTotalsV1 = function (options) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.EstimateCurrentCartTotalsV1, [options]);
    };
    SecondaryCurrentCartService.prototype.invalidateAndReload = function () {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.RefreshV1Request);
    };
    SecondaryCurrentCartService.prototype.updateLineItemsInCurrentCart = function (options) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.UpdateLineItemsInCurrentCartRequest, [
            options,
        ]);
    };
    SecondaryCurrentCartService.prototype.updateLineItemQuantityV1 = function (options, biProps) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.UpdateQuantityV1Request, [
            options,
            biProps,
        ]);
    };
    SecondaryCurrentCartService.prototype.removeLineItemsFromCurrentCart = function (options) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.RemoveLineItemsFromCurrentCartRequest, [
            options,
        ]);
    };
    SecondaryCurrentCartService.prototype.removeLineItemV1 = function (options, biProps) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.RemoveItemV1Request, [options, biProps]);
    };
    SecondaryCurrentCartService.prototype.createCheckout = function (options) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.CreateCheckoutRequest, [options]);
    };
    SecondaryCurrentCartService.prototype.createCheckoutV1 = function (options) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.CreateCheckoutV1Request, [options]);
    };
    SecondaryCurrentCartService.prototype.onLoginStart = function () {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.OnLoginStartRequest);
    };
    SecondaryCurrentCartService.prototype.onLoginFinish = function () {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.OnLoginFinishRequest);
    };
    SecondaryCurrentCartService.prototype.updateBuyerNote = function (options) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.UpdateBuyerNoteRequest, [options]);
    };
    SecondaryCurrentCartService.prototype.updateBuyerNoteV1 = function (options) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.UpdateBuyerNoteV1Request, [options]);
    };
    SecondaryCurrentCartService.prototype.addCouponToCurrentCart = function (options) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.AddCouponToCurrentCartRequest, [options]);
    };
    SecondaryCurrentCartService.prototype.applyCouponV1 = function (options, biProps) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.ApplyCouponV1Request, [options, biProps]);
    };
    SecondaryCurrentCartService.prototype.removeCouponFromCurrentCart = function (options) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.RemoveCouponFromCurrentCartRequest, [
            options,
        ]);
    };
    SecondaryCurrentCartService.prototype.removeCouponV1 = function (biProps) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.RemoveCouponV1Request, [biProps]);
    };
    SecondaryCurrentCartService.prototype.setAddress = function (options) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.SetAddressRequest, [options]);
    };
    SecondaryCurrentCartService.prototype.setAddressV1 = function (options) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.SetAddressV1Request, [options]);
    };
    SecondaryCurrentCartService.prototype.selectShippingOption = function (options) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.SelectShippingOptionRequest, [options]);
    };
    SecondaryCurrentCartService.prototype.selectShippingOptionV1 = function (options) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.SelectShippingOptionV1Request, [options]);
    };
    SecondaryCurrentCartService.prototype.addLineItemsToCurrentCart = function (options) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.AddLineItemsToCurrentCart, [options]);
    };
    SecondaryCurrentCartService.prototype.addToCurrentCartV1 = function (options) {
        return this.performActionOnMainCurrentCartService(SecondaryEvents.AddToCurrentCartV1, [options]);
    };
    SecondaryCurrentCartService.prototype.listenOnCacheChanges = function () {
        var _this = this;
        this.apis.pubSub.subscribe(SecondaryEvents.ActionResponse, function (_a) {
            var _b, _c;
            var data = _a.data;
            var _d = deserialize(data), payload = _d.payload, key = _d.key, error = _d.error;
            /* istanbul ignore else */
            if (error) {
                (_b = _this.promiseHandlers[key]) === null || _b === void 0 ? void 0 : _b.reject(error);
            }
            else {
                (_c = _this.promiseHandlers[key]) === null || _c === void 0 ? void 0 : _c.resolve(payload);
            }
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete _this.promiseHandlers[key];
        }, false);
        this.apis.pubSub.subscribe(SecondaryEvents.Updated, function () {
            _this.runCallbacks();
        }, false);
    };
    SecondaryCurrentCartService.prototype.performActionOnMainCurrentCartService = function (event, payload) {
        if (payload === void 0) { payload = undefined; }
        return __awaiter(this, void 0, void 0, function () {
            var key, promise, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.waitForPrimaryReady];
                    case 1:
                        _a.sent();
                        key = generateRequestKey(event);
                        promise = new Promise(function (resolve, reject) { return (_this.promiseHandlers[key] = { resolve: resolve, reject: reject }); });
                        data = serialize({ key: key, payload: payload });
                        this.apis.pubSub.publish(event, data, false);
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    return SecondaryCurrentCartService;
}(BaseCurrentCartService));
export { SecondaryCurrentCartService };
var generateSecondaryCurrentCartGetRequestKey = function () {
    return "".concat(Date.now(), "-").concat(Math.random());
};
var generateRequestKey = function (prefix) {
    return "".concat(prefix, "-").concat(generateSecondaryCurrentCartGetRequestKey());
};
//# sourceMappingURL=SecondaryCurrentCartService.js.map